(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.utilities').forEach((el) => observer.observe(el));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initFooter = (root) => {
      root.querySelectorAll('.nomad-footer').forEach((footer) => {
        const inner = footer.querySelector('.nomad-footer__inner');
        if (inner && !inner.classList.contains('is-visible')) {
          if ('IntersectionObserver' in window) {
            const io = new IntersectionObserver(
              (entries) => {
                entries.forEach((entry) => {
                  if (entry.isIntersecting) {
                    entry.target.classList.add('is-visible');
                    io.unobserve(entry.target);
                  }
                });
              },
              { threshold: 0.08 }
            );
            io.observe(inner);
          } else {
            inner.classList.add('is-visible');
          }
        }

        footer.querySelectorAll('.nomad-footer__local-form').forEach((form) => {
          if (form.dataset.nfInit) return;
          form.dataset.nfInit = '1';
          const details = form.querySelector('details');
          const input = form.querySelector('input[name="country_code"]');
          if (!details || !input) return;

          form.querySelectorAll('.nomad-footer__country').forEach((btn) => {
            btn.addEventListener('click', () => {
              input.value = btn.dataset.country;
              if (typeof form.requestSubmit === 'function') form.requestSubmit();
              else form.submit();
            });
          });

          document.addEventListener('click', (evt) => {
            if (details.open && !details.contains(evt.target)) details.open = false;
          });

          details.addEventListener('keyup', (evt) => {
            if (evt.key === 'Escape') {
              details.open = false;
              const summary = details.querySelector('summary');
              if (summary) summary.focus();
            }
          });
        });
      });
    };

    const initPops = (root) => {
      root.querySelectorAll('[data-nf-pop]').forEach((trigger) => {
        if (trigger.dataset.nfPopInit) return;
        trigger.dataset.nfPopInit = '1';
        trigger.addEventListener('click', (evt) => {
          const dlg = document.getElementById(trigger.dataset.nfPop);
          // sem <dialog> no navegador, o link original continua valendo
          if (!dlg || typeof dlg.showModal !== 'function') return;
          evt.preventDefault();
          dlg.showModal();
        });
      });

      root.querySelectorAll('.nf-pop').forEach((dlg) => {
        if (dlg.dataset.nfPopInit) return;
        dlg.dataset.nfPopInit = '1';

        // fecha com animacao: o <dialog> sai do DOM no mesmo quadro em que
        // close() e chamado, entao a saida so existe se esperarmos por ela
        const fecharPop = () => {
          if (dlg.dataset.nfClosing) return;
          // mesmo com "reduzir movimento" ha uma saida curta em opacidade,
          // entao nao se fecha mais no seco
          dlg.dataset.nfClosing = '1';
          dlg.classList.add('is-closing');
          const encerrar = () => {
            if (!dlg.dataset.nfClosing) return;
            delete dlg.dataset.nfClosing;
            dlg.classList.remove('is-closing');
            dlg.close();
          };
          const cartao = dlg.querySelector('.nf-pop__card');
          if (cartao) cartao.addEventListener('animationend', encerrar, { once: true });
          setTimeout(encerrar, 400);
        };

        dlg.querySelectorAll('[data-nf-close]').forEach((btn) => {
          btn.addEventListener('click', fecharPop);
        });

        // clique fora do cartao fecha
        dlg.addEventListener('click', (evt) => {
          if (!evt.target.closest('.nf-pop__card')) fecharPop();
        });

        // Esc: segura o fechamento nativo para a animacao caber
        dlg.addEventListener('cancel', (evt) => {
          evt.preventDefault();
          fecharPop();
        });

        dlg.querySelectorAll('[data-nf-copy]').forEach((btn) => {
          btn.addEventListener('click', async () => {
            const texto = btn.getAttribute('data-nf-copy') || '';
            const rotulo = btn.textContent;
            try {
              await navigator.clipboard.writeText(texto);
            } catch (e) {
              const tmp = document.createElement('textarea');
              tmp.value = texto;
              tmp.setAttribute('readonly', '');
              tmp.style.position = 'fixed';
              tmp.style.opacity = '0';
              document.body.appendChild(tmp);
              tmp.select();
              try { document.execCommand('copy'); } catch (e2) {}
              document.body.removeChild(tmp);
            }
            btn.textContent = 'Copiado';
            btn.classList.add('is-copied');
            setTimeout(() => {
              btn.textContent = rotulo;
              btn.classList.remove('is-copied');
            }, 1600);
          });
        });
      });
    };

    const boot = () => { initFooter(document); initPops(document); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', (evt) => {
      initFooter(evt.target);
      initPops(evt.target);
      evt.target.querySelectorAll('.nomad-footer__inner').forEach((el) => el.classList.add('is-visible'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-pp]').forEach((sec) => {
        if (sec.dataset.ppInit) return;
        sec.dataset.ppInit = '1';

        // galeria
        const thumbs = sec.querySelectorAll('[data-pp-thumb]');
        const slides = sec.querySelectorAll('[data-pp-slide]');
        const showSlide = (i) => {
          slides.forEach((s) => s.classList.toggle('is-active', s.dataset.ppSlide == i));
          thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.ppThumb == i));
        };
        thumbs.forEach((t) => t.addEventListener('click', () => showSlide(t.dataset.ppThumb)));

        // variantes
        const dataEl = sec.querySelector('[data-pp-variants]');
        let variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
        const idInput = sec.querySelector('[data-pp-id]');
        const priceEl = sec.querySelector('[data-pp-price]');
        const addBtn = sec.querySelector('[data-pp-add]');
        const addText = sec.querySelector('[data-pp-add-text]');
        const selects = sec.querySelectorAll('[data-pp-select]');
        const swatchGroups = sec.querySelectorAll('.pp__swatches');

        const money = (cents) => {
          try {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL' }).format(cents / 100);
          } catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
        };

        const chosen = () => {
          const vals = [];
          // ordem das opções pela posição no DOM
          sec.querySelectorAll('[data-pp-option]').forEach((opt) => {
            const sel = opt.querySelector('[data-pp-select]');
            const sw = opt.querySelector('.pp__swatch.is-active');
            if (sel) vals.push(sel.value);
            else if (sw) vals.push(sw.dataset.ppVal);
          });
          return vals;
        };

        const update = () => {
          const vals = chosen();
          const match = variants.find((v) => {
            const ov = [v.option1, v.option2, v.option3].filter((x) => x != null);
            return ov.length === vals.length && ov.every((x, i) => x === vals[i]);
          });
          if (!match) return;
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = money(match.price);
          const instEl = sec.querySelector('[data-pp-inst]');
          if (instEl) {
            var totalParc = (match.compare_at_price && match.compare_at_price > match.price)
              ? match.compare_at_price
              : Math.round(match.price / 0.9);
            instEl.innerHTML = '<strong>4x de ' + money(Math.round(totalParc / 4)) + '</strong> sem juros';
          }
          if (addBtn) {
            addBtn.disabled = !match.available;
            if (addText) addText.textContent = match.available ? (addBtn.getAttribute('data-label') || addText.textContent || 'Adicionar ao carrinho') : 'Esgotado';
            if (!match.available && addText) addText.textContent = 'Esgotado';
            if (match.available && addText && addText.textContent === 'Esgotado') addText.textContent = 'Adicionar ao carrinho';
          }
          // troca imagem se a variante tiver mídia
          if (match.featured_media && typeof match.featured_media.position === 'number') {
            showSlide(match.featured_media.position - 1);
          }
        };

        selects.forEach((s) => s.addEventListener('change', update));
        swatchGroups.forEach((g) => {
          g.querySelectorAll('.pp__swatch').forEach((sw) => {
            sw.addEventListener('click', () => {
              g.querySelectorAll('.pp__swatch').forEach((x) => x.classList.remove('is-active'));
              sw.classList.add('is-active');
              const lbl = sw.closest('.pp__option').querySelector('[data-pp-optval]');
              if (lbl) lbl.textContent = sw.dataset.ppVal;
              update();
            });
          });
        });
      });
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produto-premium"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (root) => {
      root.querySelectorAll('[data-pp]').forEach((sec) => {
        if (sec.dataset.ppInit) return;
        sec.dataset.ppInit = '1';

        // galeria
        const thumbs = sec.querySelectorAll('[data-pp-thumb]');
        const slides = sec.querySelectorAll('[data-pp-slide]');
        const showSlide = (i) => {
          slides.forEach((s) => s.classList.toggle('is-active', s.dataset.ppSlide == i));
          thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.ppThumb == i));
        };
        thumbs.forEach((t) => t.addEventListener('click', () => showSlide(t.dataset.ppThumb)));

        // variantes
        const dataEl = sec.querySelector('[data-pp-variants]');
        let variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
        const idInput = sec.querySelector('[data-pp-id]');
        const priceEl = sec.querySelector('[data-pp-price]');
        const addBtn = sec.querySelector('[data-pp-add]');
        const addText = sec.querySelector('[data-pp-add-text]');
        const selects = sec.querySelectorAll('[data-pp-select]');
        const swatchGroups = sec.querySelectorAll('.pp__swatches');

        const money = (cents) => {
          try {
            return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'BRL' }).format(cents / 100);
          } catch (e) { return 'R$ ' + (cents / 100).toFixed(2); }
        };

        const chosen = () => {
          const vals = [];
          // ordem das opções pela posição no DOM
          sec.querySelectorAll('[data-pp-option]').forEach((opt) => {
            const sel = opt.querySelector('[data-pp-select]');
            const sw = opt.querySelector('.pp__swatch.is-active');
            if (sel) vals.push(sel.value);
            else if (sw) vals.push(sw.dataset.ppVal);
          });
          return vals;
        };

        const update = () => {
          const vals = chosen();
          const match = variants.find((v) => {
            const ov = [v.option1, v.option2, v.option3].filter((x) => x != null);
            return ov.length === vals.length && ov.every((x, i) => x === vals[i]);
          });
          if (!match) return;
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = money(match.price);
          if (addBtn) {
            addBtn.disabled = !match.available;
            if (addText) addText.textContent = match.available ? (addBtn.getAttribute('data-label') || addText.textContent || 'Adicionar ao carrinho') : 'Esgotado';
            if (!match.available && addText) addText.textContent = 'Esgotado';
            if (match.available && addText && addText.textContent === 'Esgotado') addText.textContent = 'Adicionar ao carrinho';
          }
          // troca imagem se a variante tiver mídia
          if (match.featured_media && typeof match.featured_media.position === 'number') {
            showSlide(match.featured_media.position - 1);
          }
        };

        selects.forEach((s) => s.addEventListener('change', update));
        swatchGroups.forEach((g) => {
          g.querySelectorAll('.pp__swatch').forEach((sw) => {
            sw.addEventListener('click', () => {
              g.querySelectorAll('.pp__swatch').forEach((x) => x.classList.remove('is-active'));
              sw.classList.add('is-active');
              const lbl = sw.closest('.pp__option').querySelector('[data-pp-optval]');
              if (lbl) lbl.textContent = sw.dataset.ppVal;
              update();
            });
          });
        });
      });
    };
    const boot = () => init(document);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
